import axios from "axios";
import React, { useEffect, useState } from "react";
import {Link, useNavigate, useOutletContext, useParams} from "react-router-dom";
import { decodeHtml } from "../../utils/decodeHtml";
import {format_currency} from "../../utils/currencyUtils";
import AddInvoice from "../../components/Modals/Orders/AddInvoice";
import EditInvoice from "../../components/Modals/Orders/EditInvoice";
import DeleteInvoice from "../../components/Modals/Orders/DeleteInvoice";
import EditOrder from "../../components/Modals/Orders/EditOrder";
import EditContact from "../../components/Modals/Orders/EditContact";
import ReplaceContact from "../../components/Modals/Orders/ReplaceContact";
import Contracts from "../../components/Modals/Contract/Contracts";
import UploadJDModal from "../../components/Modals/createjd/UploadJDModal";
import JDOptionsModal from "../../components/Modals/createjd/JDOptions";
import toastr from "../../utils/toast";
import { openInAppTab } from "../../utils/tabNavigation";
import useSmartBack from "../../hooks/useSmartBack";

function OrderDetails() {
  const { id } = useParams();
  const navigate = useNavigate();
  const handleBack = useSmartBack("/order/list");
  const { token, setGlobalLoading } = useOutletContext();
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [invoiceFiles, setInvoiceFiles] = useState([]);
  const [data, setData] = useState({ keywords: [] });
  const [showEditOrderModal, setShowEditOrderModal] = useState(false);
  const [showEditContactModal, setShowEditContactModal] = useState(false);
  const [showReplaceContactModal, setShowReplaceContactModal] = useState(false);
  const [showAddInvoiceModal, setShowAddInvoiceModal] = useState(false);
  const [showEditInvoiceModal, setShowEditInvoiceModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [invoices, setinvoices] = useState([]);
  const [selectedOrderId, setSelectedOrderId] = useState(null);
  const [selectedContactId, setSelectedContactId] = useState(null);
  const [selectedCompanyId, setSelectedCompanyId] = useState(null);
  const [selectedRoleId, setSelectedRoleId] = useState(null);
  const [selectedAddressId, setSelectedAddressId] = useState(null);
  const [selectedItemId, setSelectedItemId] = useState(null);
  const [selectedInvoiceId, setSelectedInvoiceId] = useState(null);
  const [selectedFinalId, setSelectedFinalId] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);
  const [contractShowModel, setContractShowModel] = useState(false);
  const [selectedContractId, setSelectedContractId] = useState(null);
  const [showJDOptions, setShowJDOptions] = useState(false);
  const [showUploadJDModal, setShowUploadJDModal] = useState(false);
 
  function formatIndianNumber(input) {
    if (input === null || input === undefined || input === "") return "";
    // allow numeric strings with commas already
    const cleaned = typeof input === "number" ? input : String(input).replace(/,/g, "");
    const n = Number(cleaned);
    if (isNaN(n)) return String(input);

    const sign = n < 0 ? "-" : "";
    const [intPart, decPart] = Math.abs(n).toString().split(".");

    if (intPart.length <= 3) {
      return sign + intPart + (decPart ? "." + decPart : "");
    }

    const last3 = intPart.slice(-3);
    const rest = intPart.slice(0, -3);
    const formattedRest = rest.replace(/\B(?=(\d{2})+(?!\d))/g, ",");

    return sign + formattedRest + "," + last3 + (decPart ? "." + decPart : "");
  }
 
  const fetch_details = async () => {
    try {
      setGlobalLoading(true);
      const response = await fetch(`${API_BASE_URL}/orders/order_detail/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await response.json();
    //  console.log("Order Details:",data.order_detail);
      setData(data.order_detail);
      setinvoices(data.invoices || []);
      setInvoiceFiles(data.invoice_files || []);
      setSelectedContactId(data.order_detail.id);     
    } catch (error) {
      console.log(error);
      setGlobalLoading(false);
    } finally {
      setGlobalLoading(false);
    }
  };

  function formatTimestamp(ts) {
    const date = new Date(ts * 1000); // convert seconds → ms
    return date.toLocaleString("en-US", {
      year: "numeric",
      month: "short",
      day: "2-digit",
    });
  }

  useEffect(() => {
    fetch_details();
  }, [id, refreshKey]);

  useEffect(() => {
     if (!data?.created_date && !data?.hasJD) return;
      const createdDate = new Date(data.created_date);
      const currentDate = new Date();
      const diffInMs = currentDate - createdDate;
      const diffInDays = diffInMs / (1000 * 60 * 60 * 24);
  },[data?.created_date, data?.hasJD]);

  const OpenEditOrderModal = (id) => {
    setSelectedOrderId(id);
    setShowEditOrderModal(true);
  };
  
  const OpenEditContactModal = (contact_id, role_id, address_id) => {
    setSelectedContactId(contact_id);
    setSelectedRoleId(role_id);
    setSelectedAddressId(address_id);
    setShowEditContactModal(true);
  };

  const OpenReplaceContactModal = (company_id, role_id) => {
    setSelectedCompanyId(company_id);
    setSelectedRoleId(role_id);
    setShowReplaceContactModal(true);
  };

  const OpenAddInvoiceModal = (invoice_id) => {
    setSelectedOrderId(invoice_id);
    setGlobalLoading(true);
    setShowAddInvoiceModal(true);
  };

  const OpenEditInvoiceModal = (item_id, invoice_id, final) => {
    setSelectedItemId(item_id);
    setSelectedOrderId(invoice_id);
    setSelectedFinalId(final);
    setShowEditInvoiceModal(true);
  };
  
  const OpenDeleteInvoiceModal = (itemId, invoiceId, final) => {
      setSelectedItemId(itemId);
      setSelectedInvoiceId(invoiceId);
      setSelectedFinalId(final);
      setShowDeleteModal(true);
    };

  const totalAmount = invoices.reduce((sum, item) => {
  return sum + Number(item.amount || 0);
  }, 0);

  const handleOpenModal = (e, id) => {
    e.preventDefault();
    setSelectedContractId(id);
    setContractShowModel(true);
  };

  const generateAndDownloadJD = async () => {
      try {
        setGlobalLoading(true);
  
        const response = await axios.post(
          `${API_BASE_URL}/chatgpt/generate_jd`,
          { role_id: data.role_id },
          {
            headers: { Authorization: `Bearer ${token}` },
            responseType: "blob", // important for file download
          }
        );
        toastr.success("AI-generated JD saved successfully!");
      } catch (error) {
        console.error("Error generating JD:", error);
        toastr.error("Failed to generate Job Description");
      } finally {
        setGlobalLoading(false);
      }
    };

  return (
    <>
      <div className="content">
        <div className="row align-items-center mb-4">
          <div className="d-md-flex d-sm-block justify-content-between align-items-center flex-wrap">
            <h6 className="fw-medium d-inline-flex align-items-center mb-3 mb-sm-0">
              <a href="javascript:void(0)" onClick={handleBack}>
                <i className="ti ti-arrow-left me-2"></i>Back to Orders
              </a>
            </h6>
            </div>
        </div>
        <div className="row">
          <div className="col-12 col-lg-4 col-xl-4 col-xxl-3 theiaStickySidebar">
            <div className="card">
              <div className="card-body">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h5 className="mb-0">Orders Details</h5>
                  <button className="btn btn-primary btn-sm" onClick={() => OpenEditOrderModal(data.id)}>
                    Edit Order
                  </button>
                  {showEditOrderModal && (
                    <EditOrder
                      show={showEditOrderModal}
                      onClose={() => {
                          setShowEditOrderModal(false);
                          fetch_details();
                        }}
                      id={selectedOrderId}
                      token={token}
                      />
                    )}
                </div>
                <div className="list-group details-list-group mb-4">
                  <div className="list-group-item">
                    <div className="d-flex align-items-center justify-content-between">
                      <span>Order ID:</span>
                      <p className="text-gray-9">{data?.reference}</p>
                    </div>
                  </div>
                  <div className="list-group-item">
                    <div className="d-flex align-items-center justify-content-between">
                      <span>Company:</span>
                      <p className="text-gray-9">{data?.company}</p>
                    </div>
                  </div>
                  <div className="list-group-item">
                    <div className="d-flex align-items-center justify-content-between">
                      <span>Role:</span>
                      <p className="text-gray-9">{data?.role_name}</p>
                    </div>
                  </div>
                  <div className="list-group-item">
                    <div className="d-flex align-items-center justify-content-between">
                      <span>Expected Comp:</span>
                      <p className="text-gray-9">{data?.symbol}{" "} {format_currency(data?.expected_compensation)} ({data?.curreny_name})</p>
                    </div>
                  </div>
                  <div className="list-group-item">
                    <div className="d-flex align-items-center justify-content-between">
                      <span>Fee Percentage:</span>
                      <p className="text-gray-9">{data?.fee_percentage}</p>
                    </div>
                  </div>
                  <div className="list-group-item">
                    <div className="d-flex align-items-center justify-content-between">
                      <span>Total Fees:</span>
                      <p className="text-gray-9">{data?.symbol}{" "} {format_currency(data?.total_fees)} ({data?.curreny_name})</p>
                    </div>
                  </div>
                  <div className="list-group-item">
                    <div className="d-flex align-items-center justify-content-between">
                      <span>Raised Location Entity:</span>
                      <p className="text-gray-9">{data?.entity_name || data?.rased_location}</p>
                    </div>
                  </div>
                  <div className="list-group-item">
                    <div className="d-flex align-items-center justify-content-between">
                      <span>Purchase Order:</span>
                      <p className="text-gray-9">{data?.purchase_order}</p>
                    </div>
                  </div>
                  </div>
                <div className="list-group details-list-group mb-1">
                  {data?.candidate_name && (  
                  <div className="list-group-item">
                    <div className="d-flex align-items-center justify-content-between">
                      <span>Candidate Name:</span>
                      <p className="text-gray-9">{data?.candidate_name}</p>
                    </div>
                  </div>
                  )}
                  {Number(data?.billable_compensation) > 0 && ( 
                  <div className="list-group-item">
                    <div className="d-flex align-items-center justify-content-between">
                      <span>Billable Comp:</span>
                      <p className="text-gray-9">{data?.symbol}{" "} {format_currency(data?.billable_compensation)} ({data?.curreny_name})</p>
                    </div>
                  </div>
                  )}
                  {Number(data?.total_compensation) > 0 && ( 
                  <div className="list-group-item">
                    <div className="d-flex align-items-center justify-content-between">
                      <span>Total Comp:</span>
                      <p className="text-gray-9">{data?.symbol}{" "} {format_currency(data?.total_compensation)} ({data?.curreny_name})</p>
                    </div>
                  </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 col-lg-8 col-xl-8 col-xxl-9">
            <div className="card">
              <div className="card-body">
                <div className="bg-light rounded p-3 mb-1">
                  <div className="row">
                    <div className="col-12 col-md-6">
                      <div className="d-flex align-items-center">
                        <div>
                          <h6 className="mb-1">
                            <a
                              href={`/role/view/${data.role_id}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              onClick={(event) => {
                                event.preventDefault();
                                openInAppTab(
                                  `/role/view/${data.role_id}`,
                                );
                              }}
                            >
                              {decodeHtml(data.role_name)}
                            </a>
                          </h6>
                          <p>
                            Client :{" "}
                            <Link to={`/client/view/${data.company_id}`} target="_blank" rel="noopener noreferrer" className="text-primary">
                              {data.company}
                            </Link>
                            <span><br />Role Manager: {data?.role_manager}</span>
                            <span><br />Assigned To: {data?.assign_to}</span>
                          </p>
                        </div>
                      </div>
                    </div>
                    {contractShowModel && (
                              <Contracts
                                onClose={() => setContractShowModel(false)}
                                contractid={selectedContractId}
                              />
                            )}
                    <div className="col-12 col-md-6 text-md-end text-start mt-3 mt-md-0">
                      <div className="mb-4">
                        <span>
                          <i className="fa fa-calendar me-1"></i>{" "}
                          {formatTimestamp(data.datetime)}
                        </span>
                          <div className="list-group-item">
                            <div className="d-flex align-items-center justify-content-sm-end">
                              <span className="me-2">AGN Number:</span>
                              <div className="d-flex align-items-center">
                                <p className="text-primary mb-0 fw-bold">
                                  <a onClick={(e) =>{ e.preventDefault(); handleOpenModal(e, data?.contract_id);}}>
                                  {data?.agn}
                                  </a>          
                                </p>
                              </div>
                            </div>
                          </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card">
							<div className="card-header d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-2">
                  <h5 className="mb-0">Invoice Contacts & Address</h5>
                  
                  <div className="d-flex flex-wrap gap-2 mt-2 mt-md-0">
                    {data?.contact_name && (
                    <button className="btn btn-primary btn-sm" onClick={() => OpenEditContactModal(data.contact_id, data.role_id, data.address_id)}>
                      Edit
                    </button>
                    )}
                    <button className="btn btn-secondary btn-sm" onClick={() => OpenReplaceContactModal(data.company_id, data.role_id)}>
                      Replace
                    </button>
                  </div>
                  {showEditContactModal && (
                    <EditContact
                      show={showEditContactModal}
                      onClose={() => {
                          setShowEditContactModal(false);
                          fetch_details();
                        }}
                      id={selectedContactId}
                      role_id={selectedRoleId}
                      address_id={selectedAddressId}
                      token={token}
                      />
                   )}

                  {showReplaceContactModal && (
                    <ReplaceContact
                      show={showReplaceContactModal}
                      onClose={() => {
                          setShowReplaceContactModal(false);
                          fetch_details();
                        }}
                      company_id={selectedCompanyId}
                      role_id={selectedRoleId}
                      token={token}
                      />
                   )} 
                </div>
              {data?.contact_name ? (  
              <>  
							<div class="card-body pb-0">
								<div class="row align-items-center">
									<div className="col-12 col-sm-6 col-lg-3">
										<div class="mb-3">
											<p class="mb-1">Name</p>
											<h6 class="fw-normal">{data?.contact_name}</h6>
										</div>
									</div>
									<div className="col-12 col-sm-6 col-lg-3">
										<div class="mb-3">
											<p class="mb-1">Designation</p>
											<h6 class="fw-normal">{data?.contact_designation}</h6>
										</div>
									</div>
									<div className="col-12 col-sm-6 col-lg-3">
										<div class="mb-3">
											<p class="mb-1">Email</p>
											<h6 class="fw-normal">{data?.contact_email}</h6>
										</div>
									</div>
									<div className="col-12 col-sm-6 col-lg-3">
										<div class="mb-3">
											<p class="mb-1">Phone</p>
											<h6 class="fw-normal">{data?.contact_phone}</h6>
										</div>
									</div>
								</div>
							</div>

              <div class="card-body pb-0">
								<div class="row align-items-center">
									<div className="col-12 col-lg-6">
										<div class="mb-3">
											<p class="mb-1">Invoice Address (Bill To)</p>
											<h6 class="fw-normal">{data?.contact_address}</h6>
										</div>
									</div>
									<div className="col-12 col-lg-6">
										<div class="mb-3">
											<p class="mb-1">Cover Address (Ship To)</p>
											<h6 class="fw-normal">{data?.contact_cover_address}</h6>
										</div>
									</div>
									<div className="col-12">
										<div class="mb-3">
											<p class="mb-1">Remarks</p>
											<h6 class="fw-normal">{data?.contact_remarks}</h6>
										</div>
									</div>
								</div>
							</div>
              </>
              ) : (
                  <div className="card-body text-center py-4">
                    <p className="mb-0 text-muted">
                      No contact person selected
                    </p>
                  </div>
                )}
						</div>                  
          </div>
        </div>
      {showEditInvoiceModal && (
          <EditInvoice
            onClose={() => setShowEditInvoiceModal(false)}
            item_id={selectedItemId}
            order_id={selectedOrderId}
            onInvoiceEdited={() => setRefreshKey(prev => prev + 1)}
            token={token}                                      
          />
        )}

      {showDeleteModal && selectedItemId && selectedInvoiceId && selectedFinalId && (
        <DeleteInvoice
        onClose={() => {
            setShowDeleteModal(false);
            fetch_details();
          }}
        id={selectedItemId}
        invoice_id={selectedInvoiceId}
        final={selectedFinalId}
        />
      )}
        <div className="row">
            <div className="col-xl-12">
                        <div className="card">
                            <div className="card-header d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-2">
                                <h5>Invoices</h5>
                                <div className="ms-md-auto d-flex flex-column flex-sm-row align-items-stretch align-items-sm-center gap-2 w-100 w-md-auto">
                                  <button className="btn btn-primary btn-sm" 
                                  onClick={() => {
                                    if (!data?.contact_name) { OpenReplaceContactModal(data.company_id, data.role_id);} 
                                    // else if (checkJD === 1) { setShowJDOptions(true);}
                                    else { OpenAddInvoiceModal(selectedContactId);}
                                  }}>
                                    Add Invoice
                                  </button>
                                  {showJDOptions && (
                                    <JDOptionsModal
                                      onClose={() => setShowJDOptions(false)}
                                      onUpload={() => {
                                        setShowJDOptions(false);
                                        setShowUploadJDModal(true);
                                      }}
                                      onCreateAI={async () => {
                                        setShowJDOptions(false);
                                        await generateAndDownloadJD();
                                      }}
                                    />
                                  )}
                                  {showUploadJDModal && (
                                    <UploadJDModal
                                      roleId={data.role_id}
                                      token={token}
                                      onClose={() => setShowUploadJDModal(false)}
                                    />
                                  )}
                                  {showAddInvoiceModal && (
                                    <AddInvoice
                                      show={showAddInvoiceModal}
                                      onClose={() => setShowAddInvoiceModal(false)}
                                      order_id={selectedOrderId}
                                      onInvoiceAdded={() => setRefreshKey(prev => prev + 1)}
                                      token={token}                                      
                                    />
                                  )}
                                </div>
                            </div>
                            <div className="card-body">
                                <div className="table-responsive">
                                    <table className="table table-hover align-middle">
                                      <thead>
                                        <tr>
                                          <th scope="col">Action</th>
                                          <th scope="col">Name</th>
                                          <th scope="col">Status</th>
                                          <th scope="col">Entity</th>
                                          <th scope="col">Invoice No</th>
                                          <th scope="col">Issue Date</th>
                                          <th scope="col">Raised Date</th>
                                          <th scope="col">Amount</th>
                                          <th scope="col">Expense</th>
                                          <th scope="col">Sub Total</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                         
                                        {invoices.length > 0 ? (
                                          invoices.map((item, index) => (
                                            <tr key={index}>
                                              <td>
                                                {item.itemstatus_id <= 3 && (
                                                <div className="d-flex flex-wrap gap-2 justify-content-center">
                                                  <a href="javascript:void(0);" className="btn btn-icon btn-sm btn-light" onClick={() => OpenEditInvoiceModal(item.id,item.invoice_id,item.final_retainer)}><i className="ti ti-edit"></i></a>
                                                  <a href="javascript:void(0);" className="btn btn-icon btn-sm btn-light" onClick={() => OpenDeleteInvoiceModal(item.id,item.invoice_id,item.final_retainer)}><i className="ti ti-trash"></i></a>
                                                </div>
                                                )}
                                              </td>
                                              <td className="text-break">{item.name || "-"}</td>
                                              <td>{item.status || "-"}</td>
                                              <td>{item.entity || "-"}</td>
                                              <td>{item.invoice_number || "-"}</td>
                                              <td>{item.issue_date || "-"}</td>
                                              <td>{item.raised_date || "-"}</td>
                                              <td>{item.retainer_amount ? `${item.symbol}${formatIndianNumber(item.retainer_amount)}` : "-"}</td>
                                              <td>{item.expense_amount > 0 ? formatIndianNumber(item.expense_amount) : "-"}</td>
                                              <td>{item.amount ? `${item.symbol}${formatIndianNumber(item.amount)}` : "-"}</td>
                                            </tr>
                                          ))
                                        ) : (
                                          <tr>
                                            <td colSpan="10" className="text-center">No invoices found</td>
                                          </tr>
                                        )}
                                      </tbody>
                                      {invoices.length > 0 && (
                                        <tfoot>
                                          <tr className="fw-bold">
                                            <td colSpan="9" className="text-end text-md-end">Total</td>
                                            <td>
                                              {`${invoices[0]?.symbol || ""}${formatIndianNumber(totalAmount)}`}
                                            </td>
                                          </tr>
                                        </tfoot>
                                      )}
                                    </table>
                                </div>
                            </div>
                        </div>
            </div>

            <div className="custom-accordion-items">
                <div className="accordion accordions-items-seperate">
                <div className="accordion-item">
                  <div className="accordion-header" id="headingFour">
                    <div className="accordion-button" data-bs-toggle="collapse" data-bs-target="#primaryBorderFour" aria-expanded="false" aria-controls="primaryBorderFour">
                      <div className="d-flex align-items-center flex-fill">
                        <h5>Files</h5>
                      </div>
                    </div>
                    <div className="card-body">
                        <div className="table-responsive">
                          <table className="table table-hover align-middle">
                            <thead>
                              <tr>
                                <th scope="col">Action</th>
                                <th scope="col">Name</th>
                                <th scope="col">Description</th>
                                <th scope="col">Invoice</th>
                                <th scope="col">Filename</th>
                              </tr>
                            </thead>
                            <tbody>
                              {invoiceFiles.length > 0 ? (
                                invoiceFiles.map((files, index) => (
                                  <tr key={index}>
                                    <td>
                                      <div className="d-flex flex-wrap justify-content-center gap-2">
                                        <a
                                          href={`http://3.7.60.80:8081/media/view/${files.savename}/mediaInvoice`}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          className="btn btn-icon btn-sm btn-light"
                                          download
                                        ><i className="ti ti-download"></i></a>
                                      </div>
                                    </td>
                                    <td>{files.name || "-"}</td>
                                    <td className="text-break">{files.description || "-"}</td>
                                    <td className="text-break">{files.invoice_name || "-"}</td>
                                    <td className="text-break">{files.filename || "-"}</td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td colSpan="5" className="text-center">No files found</td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                    </div>
                  </div>
                </div>          
              </div>
            </div>
        </div>
      </div>
    </>
  );
}

export default OrderDetails;
